import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useCloseModalRestriction = () => {
  const { t } = useTranslation('schedule-generate');
  const { onOpenModal, onResetModal } = useModal();
  const navigate = useNavigate();

  const onCloseRestriction = () => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('cancelModalTitle'),
      contentDescription: t('cancelModalDesc'),
      showPrimaryButton: true,
      primaryButtonText: t('cancelModalPrimaryButton'),
      showSecondaryButton: true,
      secondaryButtonText: t('cancelModalSecondaryButton'),
      onClickPrimaryButton: () => {
        onResetModal();
        navigate('/schedule/calendar');
      },
    });
  };

  return onCloseRestriction;
};

export default useCloseModalRestriction;
